
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartRadarOverlayIec as ObiChartRadarOverlayIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-radar-overlay-iec.js';
 
 
 

 
 export const ObiChartRadarOverlayIec = createComponent({
   react: React,
   tagName: 'obi-chart-radar-overlay-iec',
   elementClass: ObiChartRadarOverlayIecElement,
   events: {
     
   }
  });
 
 